module.exports = __webpack_public_path__ + "img/full7-min.1ad20d52.png";